var map = {
	"./OMS-logo.png": 36,
	"./OMS-screenshots.jpg": 37,
	"./caftan-ahlam-logo.png": 38,
	"./caftan-ahlam-screenshots.jpg": 39,
	"./franni-logo.png": 40,
	"./franni-screenshots.jpg": 41,
	"./hatom-logo.png": 42,
	"./hatom-screenshots.jpg": 43,
	"./jood-logo.png": 44,
	"./jood-screenshots.jpg": 45,
	"./opentech-logo.png": 46,
	"./opentech-screenshots.jpg": 47,
	"./peer-logo.png": 48,
	"./peer-screenshots.jpg": 19,
	"./satfleet-logo.png": 49,
	"./satfleet-screenshots.jpg": 50,
	"./spotbills-logo.png": 51,
	"./spotbills-screenshots.jpg": 52,
	"./spotbusiness-logo.png": 53,
	"./spotbusiness-screenshots.jpg": 54,
	"./spotfit-logo.png": 55,
	"./spotfit-screenshots.jpg": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;